// extracted by mini-css-extract-plugin
export var closeButton = "_d6-1";
export var closeX = "_d6-3";
export var container = "_d6-0";
export var image = "_d6-2";